import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAdmin } from "@/admin/AdminContext";
import { PageHeader, EmptyState } from "@/admin/ui";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search, Users, ChevronRight } from "lucide-react";

export default function Clients() {
  const { version, openNewClient } = useAdmin();
  const [clients, setClients] = useState([]);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const load = () => {
    api.get("/clients", { params: { search } }).then((r) => setClients(r.data)).catch(() => {});
  };
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [search, version]);

  return (
    <div className="animate-fade-up">
      <PageHeader title="Clients" subtitle={`${clients.length} client${clients.length === 1 ? "" : "s"}`}>
        <Button onClick={openNewClient} data-testid="clients-new-button"
          className="bg-[#0D3B2D] hover:bg-[#071A13] text-white rounded-lg">New Client</Button>
      </PageHeader>

      <div className="relative mb-4">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#4A635A]" />
        <Input value={search} onChange={(e) => setSearch(e.target.value)} data-testid="clients-search-input"
          placeholder="Search by name, company or email…" className="pl-9 bg-white border-[#E2EBF0]" />
      </div>

      {clients.length === 0 ? (
        <EmptyState icon={Users} title="No clients yet" hint="Add your first client to start billing." />
      ) : (
        <div className="bg-white border border-[#E2EBF0] rounded-xl overflow-hidden" data-testid="clients-list">
          {clients.map((c) => (
            <button key={c.client_id} onClick={() => navigate(`/admin/clients/${c.client_id}`)}
              data-testid={`client-row-${c.client_id}`}
              className="w-full flex items-center justify-between px-4 py-3.5 border-b border-[#E2EBF0] last:border-0 hover:bg-[#F4FFF9] text-left transition-colors">
              <div className="min-w-0">
                <div className="font-medium text-[#0D3B2D] truncate">{c.name}</div>
                <div className="text-xs text-[#4A635A] truncate">{c.email}{c.company ? ` · ${c.company}` : ""}</div>
              </div>
              <div className="flex items-center gap-3 shrink-0">
                <span className="text-xs text-[#4A635A] font-mono">{c.service_count} svc</span>
                <ChevronRight className="h-4 w-4 text-[#BCECD8]" />
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
